import { render } from "./candidate.vue?vue&type=template&id=338b48c6"
import script from "./candidate.vue?vue&type=script&lang=js"
export * from "./candidate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__